import { Link } from 'react-router-dom';
import React from 'react';
import {
  Button,
  Card,
  CardActionArea,
  CardMedia,
  Typography,
} from '@material-ui/core';
import HomeView from '../../constants/HomeView';
import Slider from 'react-slick';
import { isMobile } from 'react-device-detect';

interface SportsBookProps {
  allowedConfig: number;
}

const HomePageGames = HomeView.HOME_PAGE_GAMES;

const settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: isMobile ? 4 : 10,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 500,
  pauseOnHover: true,
};

const SportsBook: React.FC<SportsBookProps> = ({ allowedConfig }) => {
  return (
    <>
      <div className="sr-games web-view">
        <div className="heading-ctn">
          <div className="sports-text">Sportsbook</div>
          <div className="text-border-btm"></div>
        </div>

        <Slider {...settings}>
          {HomePageGames.map((game, idx) => (
            <Link
              to={'/premium_sports'}
              className="decoration-none sportsbook-card-link"
            >
              <Card key={'incasino-game-' + idx} className="game-card">
                <CardActionArea>
                  <CardMedia
                    component="img"
                    alt={game.text}
                    className={`${game?.text} game-card-media`}
                    image={game.image ? game.image : ''}
                    title={game.text}
                  />
                </CardActionArea>
              </Card>
              <Typography gutterBottom className="game-name">
                {game.text}
              </Typography>
            </Link>
          ))}
        </Slider>
      </div>

      <div className="sr-games mob-view">
        <div className="heading-ctn">
          <div className="sports-text">Sportsbook</div>
          <div className="text-border-btm"></div>
        </div>
        <div className="sr-games-ctn">
          {HomePageGames.map((game, idx) => (
            <>
              {idx < 5 && (
                <Link
                  to={'/premium_sports'}
                  // to={game.url}
                  className="decoration-none sportsbook-card-link"
                >
                  <Card key={'incasino-game-' + idx} className="game-card">
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        alt={game.text}
                        className={`${game?.text} game-card-media`}
                        image={game.image ? game.image : ''}
                        title={game.text}
                        height={50}
                        width={50}
                      />
                    </CardActionArea>
                  </Card>
                  <Typography gutterBottom className="game-name">
                    {game.text}
                  </Typography>
                </Link>
              )}
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default SportsBook;
